"use client";

import EMICalculatorClientWrapper from "./EMICalculatorClientWrapper";

export default function EMICalculatorClientLazy(props: any) {
  return <EMICalculatorClientWrapper {...props} />;
}
